import React from 'react';
import bemHelper from 'react-bem-helper';

import policies from '../../analytics/policies';
import AdditionalText from '../AdditionalTextModule/AdditionalTextModule';
import './styles.scss';
import * as utils from '../../utils';

const bem = bemHelper({ prefix: 'toga-', name: 'tac' });

class TermsModule extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      maxHeight: 286,
      contracted: false,
      isExpanded: false
    };
  }

  componentDidMount() {
    if (!this.refs.textContainer) {
      return;
    }
    const clientHeight = this.refs.textContainer.clientHeight;
    const contracted = clientHeight >= this.state.maxHeight;
    this.setState({ contracted });
  }

  onClickHandler() {
    if (!this.state.contracted) {
      return;
    }
    this.setState({ contracted: false, isExpanded: true });
  }

  render() {
    const { termsInfo, link } = this.props;
    const haveExtraTacInfo = !!termsInfo;

    return (
      <div {...bem()}>
        <h2 {...bem('title')}>Terms and Conditions</h2>

        <div {...bem('wrapper', { columns: haveExtraTacInfo })}>
          { termsInfo && <div {...bem('container')}>
            <div ref="textContainer" {...bem('extraTermsAndConditions', { contracted: this.state.contracted })}>
              {utils.split(termsInfo).map((line, index) => {
                return <p key={index}>{line}</p>;
              })
              }</div>
            <div {...bem('view-all', { hidden: !this.state.contracted })}
                 onClick={this.onClickHandler.bind(this)}>View more
            </div>
          </div>}
          <AdditionalText link={link} defaultLink={'/about/shopper-terms'} text="terms & conditions"
                          onClickFunction={policies.registryTermsAndConditions}
                          classNames={{ expanded: this.state.isExpanded, alone: !termsInfo }}/>
        </div>
      </div>
    );
  }

}

export default TermsModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/TermsAndConditionsModule/TermsAndConditionsModule.js